export default __webpack_public_path__ + "static/media/empty_orders.9824387a.svg";